import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/cosmoV2.js';
import q from '../query.js';
export const cosmoV2Entity = 'cosmo-v2';
export const cosmoV2UserDebugKey = (userId) => `cosmo-v2-user-debug-${userId}`;
export const ensureCosmoV2UserDebugLoaded = (userId) => q.ensureLoaded(cosmoV2UserDebugKey(userId));
export const useCosmoV2UserDebugInfo = (userId) => q.query(cosmoV2UserDebugKey(userId), () => api.getDebugInfo(userId), keys.read.collection(cosmoV2Entity), {
    enabled: userId != null,
});
export const cosmoV2ProviderSubscriptionsKey = (userId) => `cosmo-v2-provider-subscriptions-${userId}`;
export const ensureCosmoV2ProviderSubscriptionsLoaded = (userId) => q.ensureLoaded(cosmoV2ProviderSubscriptionsKey(userId));
export const useCosmoV2ProviderSubscriptions = (userId) => q.query(cosmoV2ProviderSubscriptionsKey(userId), () => api.getProviderSubscriptions(userId), keys.read.collection(cosmoV2Entity), {
    enabled: userId != null,
});
export const userAssetsKey = (userId) => `user-assets-${userId}`;
export const useUserAssets = (userId) => q.query(userAssetsKey(userId ?? 'none'), () => api.getUserAssets(userId), keys.read.collection(cosmoV2Entity), {
    enabled: userId != null,
});
//# sourceMappingURL=index.js.map